import { TarificationIdEnum } from "./CommonEnums";
import { IPriceListViewModel, IProductComponentViewModel } from "./I4UViewModels";

export class PriceListUtils {
    public static showPriceEstimate(priceList: IPriceListViewModel) {
        //Cost estimate is not shown for SPOT products (energy1 productComponent's Code = SPOT_PRICE_MARGIN_CODE)
        if (priceList.ProductComponents[0].SpotEnergy1MarginalDescription !== null) {
            return false;
        }
        return true;
    }


    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
    // Esim
    // getFixedPrice(0.123, 2) => 0.12
    // getFixedPrice(0.125, 2) => 0.13
    // getFixedPrice(42, 2, 0) => 42
    // getFixedPrice(42, 2) => 42.00
    // getFixedPrice(0.123, 3, 2) => 0.123
    // getFixedPrice(0.1, 3, 2) => 0.10
    // localessa toimii joissakin tapauksissa lyhyt että pitkä tunnus esim "fi" ja "Fi-FI"
    public static getFixedPrice(price: number, maximumFractionDigits: number, minimumFractionDigits?: number, locale?: string) {
        if (price == null) {
            price = 0;
        }
        locale = locale != null ? locale : "fi-FI";
        minimumFractionDigits = minimumFractionDigits != null ? minimumFractionDigits : 2;
        return price.toLocaleString(locale, { maximumFractionDigits: maximumFractionDigits, minimumFractionDigits: minimumFractionDigits});
    }

    public static calculatePriceEstimate(priceList: IPriceListViewModel, showVat: boolean, tarification: number, energy1: number, energy2: number) {
        //Calculates price estimate including mandatory service products
        let cost = 0;
        let basicPrice = 0;
        let energy1Price = 0;
        let energy2Price = 0;
        if (showVat) {
            basicPrice = priceList.ProductComponents[0].BasicPrice;
            energy1Price = priceList.ProductComponents[0].Energy1Price;
            energy2Price = priceList.ProductComponents[0].Energy2Price;
        }
        else {
            basicPrice = priceList.ProductComponents[0].BasicPriceNoVAT;
            energy1Price = priceList.ProductComponents[0].Energy1PriceNoVAT;
            energy2Price = priceList.ProductComponents[0].Energy2PriceNoVAT;
        }
        if (tarification === TarificationIdEnum.SINGLETARIF) {
            cost = (basicPrice * 12) + ((energy1Price * energy1) / 100);
        }
        else {
            cost = (basicPrice * 12) + ((energy1Price * energy1) / 100) + ((energy2Price * energy2) / 100);
        }
        if (priceList.CountOfMandatoryServiceProducts > 0) {
            for (let i = 0; i < priceList.PriceListServiceProducts.length; i++) {
                if (priceList.PriceListServiceProducts[i].PriceListServiceProductType === 2) {
                    cost += this.calculateServiceProductPrice(priceList.PriceListServiceProducts[i].ServicePriceList.ProductComponents[0], showVat, tarification, energy1, energy2);
                }
            }
        }
        if (priceList.ProductComponents[0].AdditionalBasicPrices && priceList.ProductComponents[0].AdditionalBasicPrices.length > 0) {
            for (let additionalBasicPrice of priceList.ProductComponents[0].AdditionalBasicPrices) {
                // this assumes all basic prices have a unit of €/mo
                if (showVat) {
                    cost += (additionalBasicPrice.BasicPrice * 12)
                }
                else {
                    cost += (additionalBasicPrice.BasicPriceNoVAT + 12)
                }
            }
        }
        return cost;
    }
    public static calculateServiceProductPrice(serviceProductComponent: IProductComponentViewModel, showVat: boolean, tarification: number, energy1: number, energy2: number) {
        let cost = 0;
        //ServicePriceUnit is not translated while ServicePriceUnitTranslated is
        const priceUnit = serviceProductComponent.ServicePriceUnit.toLowerCase();
        let energy = energy1;
        if (tarification !== TarificationIdEnum.SINGLETARIF) {
            energy += energy2;
        }
        let servicePrice = serviceProductComponent.ServicePrice;
        if (!showVat) {
            servicePrice = serviceProductComponent.ServicePriceNoVAT;
        }
        switch (priceUnit) {
            //Piece or year based price
            case "eur/pcs":
            case "sek/pcs":
            case "eur/a":
            case "sek/a":
                cost = servicePrice;
                break;
            //Monthly based price
            case "eur/mo":
            case "sek/mo":
            case "eur/m":
            case "sek/m":
                cost = servicePrice * 12;
                break;
            //Consumption based price
            case "snt/kwh":
            case "öre/kwh":
            case "eur/mwh":
            case "sek/mwh":
                cost = ((servicePrice * energy) / 100);
                break;
        }
        return cost;
    }
}

